import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'searches'

const globalSearch = (axios: IFactoryFunctionRequest) => (): IFactoryResponse<Array<any>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    immediate: false,
  })
}

const updateSearchLog = (axios: IFactoryFunctionRequest) => (logId: string, data: any): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/log/${logId}`,
    data,
  })
}

const searchLogs = (axios: IFactoryFunctionRequest) => (query): IFactoryResponse<Array<any>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/history`,
    query
  })
}

export default (axios: AxiosInstance) => ({
  globalSearch: globalSearch(useAxios(axios)),
  updateSearchLog: updateSearchLog(useAxios(axios)),
  searchLogs: searchLogs(useAxios(axios)),
})
